import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqRoutingModule } from './faq-routing.module';
import { FaqComponent } from './faq.component';
import { SharedModule } from '../shared/shared.module';
import { HomeModule } from '../home/home.module';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [FaqComponent],
  imports: [
    CommonModule,
    FaqRoutingModule,
    SharedModule,
    HomeModule,
    MatExpansionModule,
  ],
})
export class FaqModule {}
